import React from 'react';
import PropTypes, {InferProps} from 'prop-types';
import {Button} from '@material-ui/core';
import {Link} from 'react-router-dom';
import type {ButtonProps} from '@material-ui/core';

function EfeLinkButton(
    props: InferProps<typeof EfeLinkButton.propTypes & ButtonProps>
) {
    const {primary, path, ...other} = props;
    return (
        <Button
            color={primary ? 'primary' : 'secondary'}
            component={Link}
            to={path}
            variant='contained'
            {...other}
        />
    );
}

EfeLinkButton.propTypes = {
    path: PropTypes.any.isRequired,
    primary: PropTypes.bool,
};

EfeLinkButton.defaultProps = {
    primary: false,
};

export default EfeLinkButton;
